import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart7: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChart7"><Path d="M5 3.00098V1.00098H3L3 23.001H5V21.0108H20.999V16.3408L5 16.3408L5 14.3409H15.499V9.6709H5L5 7.67098L9.99902 7.67098V3.00098L5 3.00098Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart7;
